import { render, staticRenderFns } from "./AttributesPainterFeatures.vue?vue&type=template&id=2b2b2d49&scoped=true&"
import script from "./AttributesPainterFeatures.vue?vue&type=script&lang=js&"
export * from "./AttributesPainterFeatures.vue?vue&type=script&lang=js&"
import style0 from "./AttributesPainterFeatures.vue?vue&type=style&index=0&id=2b2b2d49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b2d49",
  null
  
)

export default component.exports